<template>
<div>
  <div id="side-nav" class="fixed-top">
    <b-navbar vertical
              toggleable
              type="dark"
              v-if="getNavType === 'main'"
              class="main-nav main-nav-mobile"
              :class="{'partition-nav': getClient.parent}"
    >
      <div class="side-nav-list">
        <router-link
            class="nav-link  side-nav--first-item"
            to="/"
            qid="side-nav-home-link"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="home" />
          </span>
          <span class="side-nav--text">{{ $t('system.home') }}</span>
          <span class="menu-item-badge ml-2" v-if="unreadCount && getClient.projectModule">
            {{unreadCount}}
          </span>
        </router-link>

        <a class="nav-link side-nav--first-item"
           @click="showDashboardItems=!showDashboardItems"
           qid="side-nav-overview-link"
           v-if="(getClient.gdprModule && (navigation.process || navigation.activity)) || ((getClient.riskModule || getClient.advancedReportingModule) && isGranted(permissions.MAINTENANCE_VIEW))"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="chart-bar" />
          </span>
          <span class="side-nav--text">{{ $t('system.dashboard_title') }}</span>
        </a>


        <router-link
            class="nav-link nav-link-child"
            to="/regulatory"
            v-if="showDashboardItems && isGranted(permissions.MAINTENANCE_VIEW) && getClient.advancedReportingModule"
            qid="side-nav-compliance-dasboard-link"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="list-ul" />
          </span>
          <span class="side-nav--text">{{ $t('system.dashboard_regulatory_title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            to="/tree-view"
            v-if="showDashboardItems"
            qid="side-nav-tree-view-link"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="folder-tree" />
          </span>
          <span class="side-nav--text">{{ $t('tree_view.title') }}</span>
        </router-link>
        <router-link
            class="nav-link nav-link-child"
            to="/validations"
            v-if="showDashboardItems && getClient.gdprModule && (navigation.process || navigation.activity)"
            qid="side-nav-validations-link"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="check-double" />
          </span>
          <span class="side-nav--text">{{ $t('validations.title') }}</span>
        </router-link>
        <router-link
            class="nav-link nav-link-child"
            to="/risk-matrix"
            v-if="showDashboardItems && getClient.riskModule && isGranted(permissions.MAINTENANCE_VIEW)"
            qid="side-nav-risk-matrix-link"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon :icon="['fab', 'microsoft']" />
          </span>
          <span class="side-nav--text">{{ $t('risk_matrix.title') }}</span>
        </router-link>


        <router-link
            class="nav-link"
            :to="{name: 'policies'}"
            qid="policies-link"
            v-if="isGranted(permissionMap().POLICY_VIEW) && getClient.policyModule && ((user.organization && user.organization.length) || isGranted(permissions.MAINTENANCE_VIEW))"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="file-invoice" />
          </span>
          <span class="side-nav--text">{{ $t('maintenance.policies.title') }}</span>
        </router-link>


        <router-link
            class="nav-link"
            to="/processing-activities"
            qid="side-nav-processes-link"
            v-if="(navigation.process || navigation.activity) && getClient.processingActivitiesModule"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="cube" />
          </span>
          <span class="side-nav--text">{{ $t('processes.title') }}</span>
        </router-link>


        <router-link
            class="nav-link"
            to="/systems"
            qid="side-nav-systems-link"
            v-if="navigation.system && getClient.systemModule"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="desktop" />
          </span>
          <span class="side-nav--text">{{ $t('systems.title') }}</span>
        </router-link>

        <router-link
            class="nav-link"
            :to="{name: 'contracts'}"
            qid="side-nav-contracts-link"
            v-if="navigation.third_party && getClient.contractBasicModule"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="exchange-alt" />
          </span>
          <span class="side-nav--text">{{ $t('system.contract_management_title') }}</span>
        </router-link>

        <a class="nav-link side-nav--first-item"
           @click="showRiskItems=!showRiskItems"
           qid="side-nav-risk-management-link"
           v-if="getClient.riskModule && (navigation.risk_scenario || navigation.generic_control)"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="umbrella" />
          </span>
          <span class="side-nav--text">{{ $t('system.risk_management_title') }}</span>
        </a>

        <router-link
            class="nav-link nav-link-child"
            to="/risk-scenarios"
            qid="side-nav-risk-scenarios-link"
            v-if="getClient.riskModule && navigation.risk_scenario && showRiskItems"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="theater-masks" />
          </span>
          <span class="side-nav--text">{{ $t('risk_scenarios.title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            :to="{name: 'generic_controls'}"
            qid="side-nav-generic-controls-link"
            v-if="getClient.riskModule && navigation.generic_control && showRiskItems"
            @click.native="InlineButtonClickHandler()"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="shield-alt" />
          </span>
          <span class="side-nav--text">{{ $t('generic_controls.title') }}</span>
        </router-link>



        <a class="nav-link side-nav--first-item"
           @click="showProjectItems=!showProjectItems"
           qid="side-nav-project-link"
           v-if="getClient.projectModule && navigation.project"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.title') }}</span>
        </a>

        <router-link
            class="nav-link nav-link-child"
            to="/projects/gantt"
            qid="side-nav-project-management-link"
            v-if="getClient.projectModule && navigation.project && showProjectItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="chart-gantt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.gantt_overview_list_title') }}</span>
        </router-link>


        <router-link
            class="nav-link nav-link-child"
            to="/projects/asset-projects"
            qid="side-nav-project-management-link"
            v-if="getClient.projectModule && navigation.project && showProjectItems && (getClient.processingActivitiesModule || getClient.systemModule || getClient.contractBasicModule)"
        >

          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.asset_project_list_title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            to="/projects/control-projects"
            qid="side-nav-project-management-link"
            v-if="getClient.projectModule && getClient.riskModule && navigation.project && showProjectItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.control_project_list_title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            to="/projects/assessment-projects"
            qid="side-nav-project-management-link"
            v-if="getClient.projectModule && getClient.assessmentModule && navigation.project && showProjectItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.assessment_project_list_title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            to="/incidents"
            qid="side-nav-project-management-link"
            v-if="getClient.incidentModule && navigation.project && showProjectItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.incident_management_list_title') }}</span>
        </router-link>


      </div>

    </b-navbar>
    <b-navbar vertical
              toggleable
              type="dark"
              v-if="getNavType === 'main'"
              class="main-nav main-nav-lg"
              :class="{'partition-nav': getClient.parent}"
    >
      <div class="side-nav-list">
        <router-link
            class="nav-link  side-nav--first-item"
            to="/"
            qid="side-nav-home-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="home" />
          </span>
          <span class="side-nav--text">{{ $t('system.home') }}</span>
          <span class="menu-item-badge ml-2" v-if="unreadCount && getClient.projectModule">
            {{unreadCount}}
          </span>
        </router-link>
        <a class="nav-link side-nav--first-item"
           @click="showDashboardItems=!showDashboardItems"
           qid="side-nav-overview-link"
           v-if="(getClient.gdprModule && (navigation.process || navigation.activity)) || ((getClient.riskModule || getClient.advancedReportingModule) && isGranted(permissions.MAINTENANCE_VIEW))"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="chart-bar" />
          </span>
          <span class="side-nav--text">{{ $t('system.dashboard_title') }}</span>
        </a>

        <router-link
            class="nav-link nav-link-child"
            to="/regulatory"
            v-if="showDashboardItems && isGranted(permissions.MAINTENANCE_VIEW) && getClient.advancedReportingModule"
            qid="side-nav-compliance-dasboard-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="list-ul" />
          </span>
          <span class="side-nav--text">{{ $t('system.dashboard_regulatory_title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            to="/tree-view"
            v-if="showDashboardItems && getClient.gdprModule && (navigation.process || navigation.activity)"
            qid="side-nav-tree-view-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="folder-tree" />
          </span>
          <span class="side-nav--text">{{ $t('tree_view.title') }}</span>
        </router-link>
        <router-link
            class="nav-link nav-link-child"
            to="/validations"
            v-if="showDashboardItems && getClient.gdprAdvancedModule && isGranted(permissions.MAINTENANCE_VIEW)"
            qid="side-nav-validations-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="check-double" />
          </span>
          <span class="side-nav--text">{{ $t('validations.title') }}</span>
        </router-link>
        <router-link
            class="nav-link nav-link-child"
            to="/risk-matrix"
            v-if="showDashboardItems && getClient.riskModule && isGranted(permissions.MAINTENANCE_VIEW)"
            qid="side-nav-risk-matrix-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon :icon="['fab', 'microsoft']" />
          </span>
          <span class="side-nav--text">{{ $t('risk_matrix.title') }}</span>
        </router-link>


        <router-link
            class="nav-link"
            :to="{name: 'policies'}"
            qid="policies-link"
            v-if="isGranted(permissionMap().POLICY_VIEW) && getClient.policyModule && ((user.organization && user.organization.length) || isGranted(permissions.MAINTENANCE_VIEW))"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="file-invoice" />
          </span>
          <span class="side-nav--text">{{ $t('maintenance.policies.title') }}</span>
        </router-link>


        <router-link
            class="nav-link"
            to="/processing-activities"
            qid="side-nav-processes-link"
            v-if="(navigation.process || navigation.activity) && getClient.processingActivitiesModule"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="cube" />
          </span>
          <span class="side-nav--text">{{ $t('processes.title') }}</span>
        </router-link>


        <router-link
            class="nav-link"
            to="/systems"
            qid="side-nav-systems-link"
            v-if="navigation.system && getClient.systemModule"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="desktop" />
          </span>
          <span class="side-nav--text">{{ $t('systems.title') }}</span>
        </router-link>

        <router-link
            class="nav-link"
            :to="{name: 'contracts'}"
            qid="side-nav-contracts-link"
            v-if="navigation.third_party && getClient.contractBasicModule"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="exchange-alt" />
          </span>
          <span class="side-nav--text">{{ $t('system.contract_management_title') }}</span>
        </router-link>

        <a class="nav-link side-nav--first-item"
           @click="showRiskItems=!showRiskItems"
           qid="side-nav-risk-management-link"
           v-if="getClient.riskModule && (navigation.risk_scenario || navigation.generic_control)"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="umbrella" />
          </span>
          <span class="side-nav--text">{{ $t('system.risk_management_title') }}</span>
        </a>

        <router-link
            class="nav-link nav-link-child"
            to="/risk-scenarios"
            qid="side-nav-risk-scenarios-link"
            v-if="getClient.riskModule && navigation.risk_scenario && showRiskItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="theater-masks" />
          </span>
          <span class="side-nav--text">{{ $t('risk_scenarios.title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            :to="{name: 'generic_controls'}"
            qid="side-nav-generic-controls-link"
            v-if="getClient.riskModule && navigation.generic_control && showRiskItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="shield-alt" />
          </span>
          <span class="side-nav--text">{{ $t('generic_controls.title') }}</span>
        </router-link>



        <a class="nav-link side-nav--first-item"
           @click="showProjectItems=!showProjectItems"
           qid="side-nav-project-link"
           v-if="getClient.projectModule && navigation.project"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.title') }}</span>
        </a>

        <router-link
            class="nav-link nav-link-child"
            to="/projects/gantt"
            qid="side-nav-project-management-link"
            v-if="getClient.projectModule && navigation.project && showProjectItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="chart-gantt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.gantt_overview_list_title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            to="/projects/asset-projects"
            qid="side-nav-project-management-link"
            v-if="getClient.projectModule && navigation.project && showProjectItems && (getClient.processingActivitiesModule || getClient.systemModule || getClient.contractBasicModule)"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.asset_project_list_title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            to="/projects/control-projects"
            qid="side-nav-project-management-link"
            v-if="getClient.projectModule && getClient.riskModule && navigation.project && showProjectItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.control_project_list_title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            to="/projects/assessment-projects"
            qid="side-nav-project-management-link"
            v-if="getClient.projectModule && getClient.assessmentModule && navigation.project && showProjectItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.assessment_project_list_title') }}</span>
        </router-link>

        <router-link
            class="nav-link nav-link-child"
            to="/incidents"
            qid="side-nav-project-management-link"
            v-if="getClient.incidentModule && navigation.project && showProjectItems"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="calendar-alt" />
          </span>
          <span class="side-nav--text">{{ $t('projects.incident_management_list_title') }}</span>
        </router-link>


      </div>

    </b-navbar>
    <b-navbar vertical
              toggleable
              type="light"
              v-if="getNavType === 'maintenance'"
              class="main-nav"
    >
      <div class="side-nav-list">
        <div class="scrollable">
          <router-link
              class="nav-link mt-2"
              qid="navbar-brand"
              to="/"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="angle-left"/>
            </span>
              <span class="side-nav--text">{{ $t('system.home') }}</span>
          </router-link>
          <hr class="mb-0">

          <span class="nav-link nav-section text-muted">
            <span class="side-nav--icon">
              <font-awesome-icon icon="cogs" />
            </span>
            <span class="side-nav--text">{{ $t('side_nav.general_settings') }}</span>
          </span>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.partitions'}"
              qid="partitions-link"
              v-if="isGranted(permissions.PARTITION_VIEW) && !getClient.parent"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="layer-group" />
            </span>
            <span class="side-nav--text">{{ $t('administration.partitions.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.users'}"
              qid="users-owners-link"
              v-if="isGranted(permissionMap().USER_VIEW)"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="user-cog" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.users.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.data_objects'}"
              qid="data-objects-link"
              v-if="isGranted(permissionMap().DATA_OBJECT_VIEW)"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="clipboard" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.data_objects.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.process_groups'}"
              qid="process-groups-link"
              v-if="isGranted(permissionMap().PROCESS_GROUP_VIEW)"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="project-diagram" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.process_groups.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.organizations'}"
              qid="organizations-link"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="sitemap" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.organizations.title') }} </span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.measures'}"
              qid="measures-link"
              v-if="isGranted(permissionMap().MEASURE_VIEW)"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="toolbox" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.measures.title') }}</span>
          </router-link>


          <span class="nav-link nav-section text-muted" v-if="getClient.gdprModule">
            <span class="side-nav--icon">
              <font-awesome-icon icon="cogs" />
            </span>
            <span class="side-nav--text">{{ $t('side_nav.process_configuration') }}</span>
          </span>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.legal_basis'}"
              qid="legal-basis-link"
              v-if="isGranted(permissionMap().LEGAL_BASIS_VIEW) && getClient.gdprAdvancedModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="balance-scale" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.legal_basis.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.data_subjects'}"
              qid="data-subjects-link"
              v-if="isGranted(permissionMap().DATA_SUBJECT_VIEW) && getClient.gdprModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="users" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.data_subjects.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.information_obligation'}"
              qid="information-obligation-link"
              v-if="isGranted(permissionMap().INFORMATION_OBLIGATION_VIEW) && getClient.gdprAdvancedModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="envelope" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.information_obligation.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.retention_rules'}"
              qid="retention-rules-link"
              v-if="isGranted(permissionMap().RETENTION_RULE_VIEW) && getClient.gdprModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="eraser" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.retention_rules.title') }}</span>
          </router-link>


          <span class="nav-link nav-section text-muted" v-if="getClient.riskModule">
            <span class="side-nav--icon">
              <font-awesome-icon icon="cogs" />
            </span>
            <span class="side-nav--text">{{ $t('side_nav.risk_settings') }}</span>
          </span>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.frameworks'}"
              qid="control-framework-link"
              v-if="getClient.riskModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="book" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.frameworks.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.risk_categories'}"
              qid="risk-categories-link"
              v-if="getClient.riskModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="virus" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.risk_categories.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.threats'}"
              qid="threats-link"
              v-if="getClient.riskModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="meteor" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.threats.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.vulnerabilities'}"
              qid="vulnerabilities-link"
              v-if="getClient.riskModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="link" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.vulnerabilities.title') }}</span>
          </router-link>


          <span class="nav-link nav-section text-muted" v-if="getClient.assessmentModule || getClient.incidentModule">
            <span class="side-nav--icon">
              <font-awesome-icon icon="cogs" />
            </span>
            <span class="side-nav--text">{{ $t('side_nav.assessments') }}</span>
          </span>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.assessments'}"
              qid="reports-link"
              v-if="getClient.assessmentModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="file-alt" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.assessments.title') }}</span>
          </router-link>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.incident_categories'}"
              qid="incident-categories-link"
              v-if="isGranted(permissionMap().INCIDENT_CATEGORY_VIEW) && getClient.incidentModule"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="file-exclamation" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.incidents.incident_categories.title') }}</span>
          </router-link>


          <span class="nav-link nav-section text-muted">
            <span class="side-nav--icon">
              <font-awesome-icon icon="cogs" />
            </span>
            <span class="side-nav--text">{{ $t('side_nav.reports') }}</span>
          </span>
          <router-link
              class="nav-link"
              :to="{name: 'maintenance.reports'}"
              qid="reports-link"
          >
            <span class="side-nav--icon">
              <font-awesome-icon icon="cloud-download-alt" />
            </span>
            <span class="side-nav--text">{{ $t('maintenance.reports.title') }}</span>
          </router-link>

        </div>


      </div>

    </b-navbar>

    <b-navbar vertical
              toggleable
              type="light"
              v-if="getNavType === 'administration'"
              class="main-nav"
    >
      <div class="side-nav-list">

        <router-link
            class="nav-link mt-2"
            qid="navbar-brand"
            to="/"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="angle-left"/>
          </span>
            <span class="side-nav--text">{{ $t('system.home') }}</span>
        </router-link>
        <hr class="mb-0">

        <span class="nav-link nav-section text-muted side-nav--first-item">
          <span class="side-nav--icon">
            <font-awesome-icon icon="cogs" />
          </span>
          <span class="side-nav--text">{{ $t('dashboard.administration') }}</span>
        </span>
        <router-link
            class="nav-link side-nav--first-item"
            to="/administration/clients"
            qid="administration-clients-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="layer-group" />
          </span>
          <span class="side-nav--text">{{ $t('dashboard.clients') }}</span>
        </router-link>
        <router-link
            class="nav-link"
            to="/administration/users"
            qid="administration-users-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="user-cog" />
          </span>
          <span class="side-nav--text">{{ $t('dashboard.users') }}</span>
        </router-link>
        <router-link
            class="nav-link"
            to="/administration/guide"
            qid="administration-guide-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="book-open" />
          </span>
          <span class="side-nav--text">{{ $t('dashboard.guide') }}</span>
        </router-link>
        <router-link
            class="nav-link"
            to="/administration/settings"
            qid="administration-settings-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="cogs" />
          </span>
          <span class="side-nav--text">{{ $t('dashboard.settings') }}</span>
        </router-link>
        <router-link
            class="nav-link"
            to="/administration/features"
            qid="administration-features-link"
        >
          <span class="side-nav--icon">
            <font-awesome-icon icon="cogs" />
          </span>
          <span class="side-nav--text">{{ $t('administration.features.title') }}</span>
        </router-link>
      </div>

    </b-navbar>
  </div>
</div>
</template>

<script>

  import roleCheck from '../util/ACL/permissionCheck.js'
  import permissionMap from '../util/ACL/permissionMap.js'
  import permissionCheck from "../util/ACL/permissionCheck";
  import piincHttp from '@/util/configureAxios.js';
export default {
  name: 'SideNavigation',
  data: function() {
    return {
      navigation: [],
      user: {},
      activeNavbar: this.$store.state.activeNavbar,
      unreadCount: 0,
      showDashboardItems: this.$route.name == 'treeView' || this.$route.name == 'validations' || this.$route.name == 'riskMatrix' ? true : false,
      showMappingItems: this.$route.name == 'processes' || this.$route.name == 'activities' || this.$route.name == 'systems' || this.$route.name == 'processes.view' || this.$route.name == 'activities.view' || this.$route.name == 'systems.view' || this.$route.name == 'processes.create' || this.$route.name == 'activities.create' || this.$route.name == 'systems.create' ? true : false,
      showContractItems: this.$route.name == 'contracts' || this.$route.name == 'contracts.third_parties' || this.$route.name == 'contracts.view' || this.$route.name == 'contracts.third_parties.view' || this.$route.name == 'contracts.create' || this.$route.name == 'contracts.third_parties.create' ? true : false,
      showRiskItems: this.$route.name == 'generic_controls' || this.$route.name == 'risk_scenarios' || this.$route.name == 'generic_controls.view' || this.$route.name == 'risk_scenarios.view' || this.$route.name == 'generic_controls.create' || this.$route.name == 'risk_scenarios.create' ? true : false,
      showProjectItems: this.$route.name == 'projects' || this.$route.name == 'projects.view' || this.$route.name == 'projects.create' || this.$route.name == 'ProjectsLanding' || this.$route.name == 'AssetProjectsList' || this.$route.name == 'ControlProjectsList' || this.$route.name == 'AssessmentProjectsList' || this.$route.name == 'incidents.view' || this.$route.name == 'IncidentsList' ? true : false,
    }
  },
  props: {

  },
  watch: {
    getClient: function () {
      this.loadCount()
      this.loadNavigation()
    },
    getReloadCount: function () {
      this.loadCount()
    },
  },
  computed: {
    getNavType() {
      return this.$store.state.activeNavbar
    },
    getClient() {
      return this.$store.state.client
    },
    getReloadCount() {
      return this.$store.state.reloadCount
    },
    getUser() {
      return this.$store.state.user
    }
  },
  methods: {
    InlineButtonClickHandler(){
      let topElement = document.getElementById("app");
      topElement.classList.toggle("sidebar-collapsed");
    },
    isGranted(permission) {
      return permissionCheck(permission)
    },
    permissionMap() {
      return permissionMap;
    },
    loadCount() {
      let self = this;
      if (this.getClient.projectModule) {
        piincHttp.get('projects/me/tasks', { params:
          {
            count: 1,
            status: 'pending',
            client: this.getClient.slug
          }
        }).then(function (response) {
          self.unreadCount = response.data.total_count;

          piincHttp.get('validations/rejected', { params:
            {
              count: 1,
              client: self.getClient.slug
            }
          }).then(function(response) {
            self.unreadCount = self.unreadCount + response.data.total_count;
          }, function() {});
        }, function () {});
      }
    },
    loadNavigation() {
      let self = this;
      piincHttp.get('users/me/navigation', { params:
        {
          client: this.getClient.slug
        }
      }).then(function (response) {
        self.navigation = response.data;
      }, function () {});
    },
    loadUser(){
      let self = this;
      piincHttp.get('users/' + self.getUser.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.user = response.data;
      }, function() {});
    },
  },
  created() {
    if (this.getClient && this.getClient.slug) {
      this.loadNavigation()
      this.loadUser()
      this.loadCount()
    }
  }
}
</script>
